import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft, Menu, X, FileText, Shield, CreditCard } from 'lucide-react';
import { useState, useEffect } from 'react';
import QuickSignLogo from '../assets/QuickSign.svg';
import './Header.css';

function Header({ showBackButton = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogoClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
    }
  };

  const handleBackClick = () => {
    navigate('/');
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuItemClick = (path) => {
    setIsMenuOpen(false);
    navigate(path);
  };

  // Закрытие меню по Escape
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('keydown', handleEscape);
      // Блокируем скролл body когда меню открыто
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <>
      <header className="app-header">
        <div className="header-container">
          {showBackButton ? (
            <button className="back-button" onClick={handleBackClick}>
              <ArrowLeft size={20} />
              Назад
            </button>
          ) : (
            <button 
              className="menu-button" 
              onClick={toggleMenu}
              aria-label="Открыть меню"
            >
              <Menu size={22} />
            </button>
          )}
          <div className="logo-wrapper" onClick={handleLogoClick}>
            <img src={QuickSignLogo} alt="QuickSign" className="logo" />
          </div>
          {showBackButton && <div className="menu-button-placeholder"></div>}
        </div>
      </header>

      {/* Overlay */}
      {isMenuOpen && (
        <div 
          className="menu-overlay" 
          onClick={() => setIsMenuOpen(false)}
        />
      )}

      {/* Слайдинг-меню */}
      <div className={`sliding-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="sliding-menu-header">
          <h2>Меню</h2>
          <button 
            className="menu-close-button" 
            onClick={() => setIsMenuOpen(false)}
            aria-label="Закрыть меню"
          >
            <X size={24} />
          </button>
        </div>
        
        <nav className="sliding-menu-content">
          <button 
            className="sliding-menu-item" 
            onClick={() => handleMenuItemClick('/saved-card')}
          >
            <CreditCard size={20} />
            <span>Способы оплаты</span>
          </button>

          <div className="menu-divider"></div>
          
          <button 
            className="sliding-menu-item" 
            onClick={() => handleMenuItemClick('/offer')}
          >
            <FileText size={20} />
            <span>Публичная оферта</span>
          </button>
          
          <button 
            className="sliding-menu-item" 
            onClick={() => handleMenuItemClick('/privacy')}
          >
            <Shield size={20} />
            <span>Политика конфиденциальности</span>
          </button>
        </nav>

        <div className="sliding-menu-footer">
          <p className="menu-version">QuickSignAi v1.0</p>
        </div>
      </div>
    </>
  );
}

export default Header;

